import * as angular from 'angular';
import * as _ from 'underscore';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { ClassificationCategoryListItem } from '../../../app.retailer/modules/core';
import { RetailerServiceBase } from '../services/retailer.service';
import { CategoriesServiceBase } from './categories.service';

export class ClassificationCategoriesService extends CategoriesServiceBase<ClassificationCategoryListItem> {
    public static $inject = ['http', 'commonRetailerService'];

    public categoryType = 2;

    private categoriesWithParents: number[][] = null;

    constructor(
        http: HttpService,
        private commonRetailerService: RetailerServiceBase,
    ) {
        super(http);
    }

    protected getApiUrl(): string {
        return this.commonRetailerService.classificationCategoriesForInventory();
    }

    public async getWithParents() {
        if (!this.categoriesWithParents) {
            const list = await this.getList();
            this.categoriesWithParents = [];
            list.forEach((category) => {
                this.categoriesWithParents[category.ID] = this.toParent(category);
            });
        }
        return this.categoriesWithParents;
    }

    public getClassificationCategoriesForRules = () => {
        return this.http.get<ClassificationCategoryListItem[]>(this.commonRetailerService.classificationCategoriesForRules());
    }

    public categoriesSearch = (keywords: string) => {
        return this.http.get<number[]>(this.commonRetailerService.classificationCategoriesSearch(), { params: { keywords } });
    }

    public getCountry(): any {
        return this.http.get(this.commonRetailerService.country()).then((country: any) => {
            return country;
        });
    }

    private toParent(category: ClassificationCategoryListItem) {
        const list = [category.ID];

        while (category && category.ParentID) {
            category = _.findWhere(this.list, { ID: category.ParentID });
            if (!_.isUndefined(category)) {
                list.push(category.ID);
            }
        }
        return list;
    }
}

angular
    .module('app.retailes.common')
    .service('classificationCategoriesService', ClassificationCategoriesService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/classification-categories.service.ts